export const bgColors = {
    bodyBg: "#FFFFFF",
    headFootBg: "#999798",
    searchBarBg: "#c7c5c6",
};
export const elmColors = {
    navIconColor: "#5185cf",
};
export const rainbowColors = {
    red: "#ff0000",
    orange: "#edaf19",
    yellow: "#edd219",
    green: "#329b1e",
    blue: "#1463a7",
    purple: "#9e479b",
};
/* export const fonts = {
    head: "#FFFFFF",
    headLights : "#FFD239",
    navyBody: "#002D67",
    blurryBlackBody: "#393939",
    yellowLightsBody: "#FFA939",
};
export const visualElm = {
    brightnessToolElm : "#C3C3C3",
}; */